export const siteInfo = {
  name: '黑料首页',
  shortName: '黑料',
  slogan: '首屏新内容，实时上新',
  subtitle: '最新动态与轮播更新，抢先看',
  description:
    '黑料首页首屏区保持高频刷新，最新动态、轮播更新、新内容持续上架。不管你是蹲新瓜还是追后续，这里都能让你第一时间看到刚出炉的爆料与实锤，不错过任何一条新鲜猛料。',
  email: 'hello@heiliao-front.example',
  tipEmail: 'tips@heiliao-front.example',
  workingHours: '编辑值守：每日 09:00 - 24:00',
  since: '2021',
  stats: [
    { label: '累计话题', value: '2,860+' },
    { label: '日均上新', value: '46 条' },
    { label: '更新主播', value: '320+' },
    { label: '栏目数量', value: '6 个' },
  ],
};